import React, { Component, PropTypes } from 'react';

class SvgIcon extends Component {
  render() {
    let style = Object.assign({}, this._getDefaultStyle(), this.props.style)

    return (
      <svg viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet" style={style}>
        { this._renderGraphic() }
      </svg>
    );
  }

  _renderGraphic() {
    switch (this.props.icon) {
      case 'myo':
        return (
          <g>
            <path d="M23.15,6.91a12.89,12.89,0,0,0-3.51-2.08h0l0,0c-.29-.1-1.22-.35-1.21,1,0,.27,0,.95.05,1.79a.16.16,0,0,1,0,0c0,.2-.4.31-.7.25s-.56-.25-.56-.47V7.2c0-2.47-.06-3.53-.9-3.74A15.25,15.25,0,0,0,12.4,3H11.6a15.25,15.25,0,0,0-3.82.48c-.85.21-.9,1.27-.9,3.74v.23c0,.22-.26.41-.56.47s-.66-.06-.7-.25a.16.16,0,0,1,0,0c0-.84,0-1.51.05-1.79,0-1.37-.92-1.11-1.21-1l0,0h0A12.92,12.92,0,0,0,.85,6.91,2.21,2.21,0,0,0,0,8.65v7.52a2.16,2.16,0,0,0,.77,1.68C2.16,19,5.52,21,11.94,21h.12c6.43,0,9.78-2,11.17-3.18A2.16,2.16,0,0,0,24,16.17V8.65a2.23,2.23,0,0,0-.85-1.74M21.68,16.3a.77.77,0,0,1-.42.71A19.05,19.05,0,0,1,12,19.29,19.15,19.15,0,0,1,2.74,17a.77.77,0,0,1-.42-.71v0a.8.8,0,0,1,.58-.77s1.37-.36,1.65-.46a1.63,1.63,0,0,0,.87-1.62c0-.25,0-1,0-1.86,0-.18.31-.34.62-.38s.67.08.69.27a.15.15,0,0,1,0,.06c0,.75,0,1.37,0,1.77,0,1.06.33,1.54,1.7,1.48,1.12-.06,2.78-.1,3.35-.1h.42c.58,0,2.24,0,3.35.1,1.37.06,1.7-.42,1.7-1.48,0-.4,0-1,0-1.77a.3.3,0,0,1,0-.06c0-.18.38-.3.69-.27s.62.2.62.38c0,.9,0,1.61,0,1.86A1.63,1.63,0,0,0,19.44,15c.28.11,1.65.46,1.65.46a.8.8,0,0,1,.58.77v0Z" fill="#031a26"/>
            <path d="M11.79,7a1.73,1.73,0,1,1,0,3.46,1.67,1.67,0,0,1-1.67-1.73A1.67,1.67,0,0,1,11.79,7" fill="#00bbde"/>
          </g>
        );

      case 'battery':
        return (
          <g>
            <path d="M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"/>
          </g>
        );

      case 'synced':
        return (
          <g>
            <path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"/>
          </g>
        ); 

      case 'unsynced':
        return (
          <g>
            <path d="M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24C5.68 15.15 5 13.66 5 12c0-2.61 1.67-4.83 4-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24C18.32 8.85 19 10.34 19 12c0 2.61-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z"/>
          </g>
        );

      case 'checked':
        return (
          <g>
            <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </g>
        );
      
      case 'unchecked':
        return (
          <g>
            <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>
          </g>
        );

      case 'chevron-left':
        return (
          <g>
            <path d="M19.11,2.82,16.3,0,4.3,12l12,12,2.82-2.82L10,12Z"/>
          </g>
        );
        
      case 'chevron-right':
        return (
          <g>
            <path d="M7.7,0,4.89,2.82,14,12,4.89,21.18,7.7,24l12-12Z"/>
          </g>
        );

      case 'fullscreen':
        return (
          <g>
            <path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/>
          </g>
        );

      case 'df-logo':
        return (
          <g>
            <path d="M24,7.49V5.95H16.39v5.36H10.54q0-.26-.08-.54a6.57,6.57,0,0,0-.39-1.33,6,6,0,0,0-.74-1.3A4.93,4.93,0,0,0,8.15,7a6,6,0,0,0-1.68-.78,7.84,7.84,0,0,0-2.25-.29H0V18.05H3.95a7.44,7.44,0,0,0,2.86-.51,6.23,6.23,0,0,0,2.08-1.36,5.68,5.68,0,0,0,1.27-1.93,6.11,6.11,0,0,0,.38-1.5h5.85v5.31H18V12.82h5.56V11.28H18V7.49ZM8.43,14a4,4,0,0,1-1.11,1.41,4.79,4.79,0,0,1-1.63.85,6.79,6.79,0,0,1-2,.28H1.64v-9H4.1A5.12,5.12,0,0,1,6.5,8,4.21,4.21,0,0,1,7.94,9.16a4.07,4.07,0,0,1,.71,1.48c.06.24.1.46.13.67H4.48v1.44H8.79A4.08,4.08,0,0,1,8.43,14"/>
          </g>
        );

      case 'play':
        return (
          <g>
            <path d="M8 5v14l11-7z"/>
          </g>
        );

      case 'pause':
        return (
          <g>
            <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
          </g>
        );

      default:
        return false;
    }
  }

  _getDefaultStyle() {
    return {
      fill: "currentcolor",
      verticalAlign: "middle",
      width: this.props.size,
      height: this.props.size
    }
  }
}

SvgIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  style: PropTypes.object
}

SvgIcon.defaultProps = {
  size: 24
}

export default SvgIcon;


/** WEBPACK FOOTER **
 ** ./src/components/SvgIcon.js
 **/